export default __webpack_public_path__ + "static/media/format-icon.da56516b.svg";